import Gobalstore from "../index";
export const actions = {
  getDocMaster: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/document/`,
    })
      .then(function (response) {
        localStore.commit("setDocMaster", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  createDocMaster: function (localStore, data) {
    this.axios({
      method: "POST",
      url: `/admin/guarded/management/document/`,
      data: data,
    }).then(function (response) {
      localStore.commit("pushDocMaster", response.data);
      Gobalstore.commit("snackbarSuccess", true);
    });
  },

  updateDocMaster: function (localStore, data) {
    this.axios({
      method: "PUT",
      url: `/admin/guarded/management/document/`,
      data: data,
    }).then(function (response) {
      localStore.commit("updateDocMaster", response.data);
      Gobalstore.commit("snackbarSuccess", true);
    });
  },

  deleteDocMaster: function (localStore, data) {
    this.axios({
      method: "DELETE",
      url: `/admin/guarded/management/document/`,
      data: data,
    }).then(function (response) {
      localStore.commit("removeDocMaster", data);
      Gobalstore.commit("snackbarSuccess", true);
    });
  },
};
